module.exports = __webpack_public_path__ + "static/media/main_slide_220215_m.2a2d92f8.jpg";